// This file contains all instrument constants used in the application.
// The catalog below was expanded from broad internet references (A-Z indexes and
// encyclopedic instrument lists) and normalized for UI search usage.

const RAW_INSTRUMENTS = [
    // Guitar and bass family
    'Guitar',
    'Lead Guitar',
    'Rhythm Guitar',
    'Electric Guitar',
    'Acoustic Guitar',
    'Classical Guitar',
    '12-string Guitar',
    '7-string Guitar',
    '8-string Guitar',
    '9-string Guitar',
    'Steel Guitar',
    'Pedal Steel Guitar',
    'Lap Steel Guitar',
    'Resonator Guitar',
    'Slide Guitar',
    'Harp Guitar',
    'Overtone Guitar',
    'Baritone Guitar',
    'Guitar 12 Strings',
    'Bass Guitar',
    'Acoustic Bass Guitar',
    'Electric Bass',
    'Fretless Bass',
    'Double Bass',
    'Upright Bass',
    'Washtub Bass',
    'Tea Chest Bass',
    'Bordonua',
    'Guitarron',
    'Rajao',
    'Cavaquinho',
    'Cavaco',
    'Cuatro',
    'Vihuela',
    'Bandurria',
    'Bandola',
    'Tres',
    'Cittern',
    'Lute',
    'Archlute',
    'Oud',
    'Ud',
    'Barbat',
    'Sitar',
    'Setar',
    'Tar',
    'Dotara',
    'Dutar',
    'Tanbur',
    'Yayli Tanbur',
    'Bouzouki',
    'Balalaika',
    'Domra',
    'Mandolin',
    'Mandola',
    'Tenor Mandola',
    'Octave Mandolin',
    'Mandocello',
    'Mando-bass',
    'Soprano Mandolin',
    'Banjo',
    'Xalam',
    'Khalam',
    'Ukulele',
    'Timple',
    'Chapman Stick',

    // Bowed strings and related
    'Violin',
    'Fiddle',
    'Hardanger Fiddle',
    'Viola',
    'Vertical Viola',
    'Viola d\'Amore',
    'Cello',
    'Crwth',
    'Nyckelharpa',
    'Erhu',
    'Gaohu',
    'Zhonghu',
    'Zhongdihu',
    'Dadihu',
    'Jiaohu',
    'Leiqin',
    'Sihu',
    'Tuhu',
    'Dahu',
    'Xiaodihu',
    'Diyingehu',
    'Jinghu',
    'Maguhu',
    'Morin Khuur',
    'Igil',
    'Rebab',
    'Rebec',
    'Lirone',

    // Harps, zithers, and plucked traditional strings
    'Harp',
    'Hooked Harp',
    'Aeolian Harp',
    'Lyre',
    'Kissar',
    'Psaltery',
    'Zither',
    'Hammered Dulcimer',
    'Dulcimer',
    'Appalachian Dulcimer',
    'Santur',
    'Cymbalum',
    'Yangqin',
    'Yang Chin',
    'Qanun',
    'Guzheng',
    'Gayageum',
    'Komungo',
    'Koto',
    'Yazheng',
    'Valiha',
    'Tjelempung',
    'Celempung',
    'Se',
    'Ruan',
    'Yueqin',
    'Pipa',
    'Biwa',
    'Shamisen',
    'Vichitra Veena',
    'Rudra Veena',
    'Saraswati Veena',
    'Ektara',
    'Laruan',
    'Knatela',
    'Moodswinger',

    // Keyboard and free-reed instruments
    'Piano',
    'Digital Piano',
    'Electric Piano',
    'Keyboard',
    'Synthesizer',
    'Organ',
    'Electric Organ',
    'Pipe Organ',
    'Reed Organ',
    'Harmonium',
    'Harpsichord',
    'Clavichord',
    'Clavinet',
    'Celesta',
    'Accordion',
    'Chromatic Accordion',
    'Button Accordion',
    'Bayan',
    'Melodeon',
    'Concertina',
    'Bandoneon',
    'Mellotron',
    'Calliope',
    'Fingerboard Synthesizer',
    'Synclavier',
    'Ondes Martenot',

    // Woodwinds, reeds, and flutes
    'Flute',
    'Transverse Flute',
    'Bass Flute',
    'Contrabass Flute',
    'Double Contrabass Flute',
    'Subcontrabass Flute',
    'Piccolo',
    'Recorder',
    'Tonette',
    'Whistle',
    'Tin Whistle',
    'Slide Whistle',
    'Ocarina',
    'Pan Flute',
    'Duct Flute',
    'Vertical Flute',
    'Xiao',
    'Xun',
    'Paixiao',
    'Pulalu',
    'Palendang',
    'Tumpong',
    'Inci',
    'Washint',
    'Koudi',
    'Chi',
    'Ryuteki',
    'Shakuhachi',
    'Ney',
    'Nay',
    'Kaval',
    'Khloy',
    'Bawu',
    'Lusheng',
    'Sheng',
    'Saenghwang',
    'Yu',
    'Launeddas',
    'Clarinet',
    'Soprano Clarinet',
    'Sopranino Clarinet',
    'Piccolo Clarinet',
    'Bass Clarinet',
    'Alto Clarinet',
    'Contra-alto Clarinet',
    'Octocontra-alto Clarinet',
    'Octocontrabass Clarinet',
    'Basset Horn',
    'Saxophone',
    'Sopranino Saxophone',
    'Soprano Saxophone',
    'Alto Saxophone',
    'Tenor Saxophone',
    'Baritone Saxophone',
    'Bass Saxophone',
    'Subcontrabass Saxophone',
    'Aulochrome',
    'Saxonette',
    'Sarrusophone',
    'Tenor Sarrusophone',
    'Bass Sarrusophone',
    'Contrabass Sarrusophone',
    'Oboe',
    'Piccolo Oboe',
    'Oboe d\'Amore',
    'Oboe da Caccia',
    'English Horn',
    'Piccolo Heckelphone',
    'Dulcian',
    'Tenoroon',
    'Bassoon',
    'Hichiriki',
    'Serunai',
    'Sorna',
    'Zurna',
    'Shawm',
    'Dulzaina',
    'Bombarde',
    'Sralai',
    'Trompeta China',
    'Mijwiz',
    'Arghul',
    'Crumhorn',
    'Cromorne',

    // Brass and natural horns
    'Trumpet',
    'Keyed Trumpet',
    'Natural Trumpet',
    'Trumpet in Bb',
    'Cornet',
    'Flugelhorn',
    'Trombone',
    'Tromboon',
    'French Horn',
    'Hunting Horn',
    'Mellophone',
    'Saxhorn',
    'Alto Horn',
    'Tenor Horn',
    'Baritone Horn',
    'Euphonium',
    'Basse a Pistons',
    'Baryton',
    'Tuba',
    'Wagner Tuba',
    'Roman Tuba',
    'Sousaphone',
    'Ophicleide',
    'Quinticlave',
    'Serpent',
    'Bugle',
    'Keyed Bugle',
    'Oliphant',
    'Cor d\'Oliphant',
    'Didgeridoo',
    'Conch',
    'Shofar',
    'Horagai',

    // Bagpipes and related aerophones
    'Bagpipes',
    'Great Highland Bagpipe',
    'Great Irish Warpipes',
    'Irish Uilleann Pipes',
    'Scottish Smallpipes',
    'Border Pipes',
    'Pastoral Pipes',
    'Welsh Pipes',
    'Gaita',
    'Gaida',
    'Doedelzak',
    'Dudelsack',
    'Sackpipa',
    'Cabrette',
    'Biniou',
    'Boha',
    'Piva',
    'Musette du Centre',
    'Musette Bressane',
    'Cimpoi',
    'Dankiyo',
    'Tulum',
    'Torupill',
    'Mizwad',
    'Tsampouna',
    'Volinka',
    'Dudy',
    'Huemmelchen',
    'Brian Boru Bagpipes',
    'Lancashire Great-pipe',
    'Istarski Mih',
    'Croatian Bagpipes',
    'Schweizer Sackpfeife',
    'Mittlealtersackpfeife',
    'Muchosac',

    // Percussion, drums, and idiophones
    'Drums',
    'Drum Kit',
    'Percussion',
    'Snare Drum',
    'Bass Drum',
    'Tom-tom',
    'Timpani',
    'Kettle Drum',
    'Tabla',
    'Mridangam',
    'Dhol',
    'Chenda',
    'Daiko',
    'Tsuri-daiko',
    'Octaban',
    'Congas',
    'Bongos',
    'Bongo Drum',
    'Cuica',
    'Dun Dun',
    'Gan Gan',
    'Talking Drum',
    'Sabar',
    'Sampho',
    'Taphon',
    'Naqara',
    'Ghatam',
    'Janggu',
    'Khol',
    'Lambeg',
    'Dabakan',
    'Tagutok',
    'Slit Drum',
    'Djembe',
    'Cajon',
    'Xylophone',
    'Xylorimba',
    'Marimba',
    'Glass Marimba',
    'Lithophone',
    'Ranat Ek Lek',
    'Ranat Thum Lek',
    'Gandingan',
    'Gandingan a Kayo',
    'Kulintang',
    'Kulintang a Kayo',
    'Kulintang a Putao',
    'Kwintangen Kayo',
    'Malimba',
    'Fangxiang',
    'Bianqing',
    'Gong',
    'Yun Lo',
    'Babendil',
    'Agung',
    'Agong',
    'Agung a Tamlang',
    'Crotales',
    'Cymbals',
    'Hi-hat',
    'Finger Cymbals',
    'Handbells',
    'Bell',
    'Alpine Bell',
    'Wind Chimes',
    'Chimes',
    'Tubular Bells',
    'Glockenspiel',
    'Triangle',
    'Cowbell',
    'Ratchet',
    'Rattle',
    'Shaker',
    'Ahoko',
    'Hosho',
    'Caxixi',
    'Ipu',
    'Ganza',
    'Spoons',
    'Washboard',
    'Guiro',
    'Castanets',
    'Tambourine',
    'Sleigh Bells',
    'Singing Bowl',
    'Siren',

    // Electronic instruments and controllers
    'DJ Equipment',
    'Drum Machine',
    'Sampler',
    'Theremin',
    'Vocoder',
    'Groovebox',
    'MIDI Controller',
    'Launchpad',
    'Turntables',
    'Ableton Push',
    'Electronic Wind Instrument',
    'Octapad',

    // Voice and vocal styles
    'Vocals',
    'Lead Vocals',
    'Backing Vocals',
    'Soprano',
    'Alto',
    'Tenor',
    'Bass (Vocal)',
    'Beatboxing',
    'Rap',
    'Screaming',
    'Growling',

    // Legacy entries kept for continuity
    'Viola da Gamba',
    'Steel Drums',
    'Vibraphone',
    'Celesta',
    'Mellotron',
    'Clavinet',
    'Recorder (Descant)',
    'Harmonica',
    'Pan Flute',
    'Ocarina',
    'Kalimba',
    'Erhu',
    'Guzheng',
    'Shamisen',
    'Nyckelharpa',
    'Hurdy-gurdy',
    'Bouzouki',
    'Balalaika',
    'Tar',
    'Zurna'
];

const normalizeInstrumentLabel = (value) => value.trim().replace(/\s+/g, ' ');

const dedupedInstruments = [];
const seenInstruments = new Set();

for (const instrument of RAW_INSTRUMENTS) {
    if (typeof instrument !== 'string') {
        continue;
    }

    const normalized = normalizeInstrumentLabel(instrument);
    if (!normalized) {
        continue;
    }

    const key = normalized.toLowerCase();
    if (seenInstruments.has(key)) {
        continue;
    }

    seenInstruments.add(key);
    dedupedInstruments.push(normalized);
}

export const INSTRUMENTS = [...dedupedInstruments, 'Other'];

export default INSTRUMENTS;
